import { Component } from '@angular/core';
import { NavbarComponent } from "../../partials/navbar/navbar.component";
import { FooterComponent } from "../../partials/footer/footer.component";
import { Title } from '@angular/platform-browser';
import { LanguageService } from '../../services/language.service';

@Component({
  selector: 'app-cookies-page',
  standalone: true,
  imports: [NavbarComponent, FooterComponent],
  templateUrl: './cookies-page.component.html',
  styleUrl: './cookies-page.component.css'
})
export class CookiesPageComponent {
  texts: any;
  constructor(private langService:LanguageService, private title:Title){
    this.texts = this.langService.getWebisteTexts().cookies_policy;
  
    if (this.langService.getLanguage() == 'es') {
      this.title.setTitle('PRINX - Política de Cookies') 
    }else{
      this.title.setTitle('PRINX - Cookies policy')
    }
  }
}
